// src/services/ProductService.ts

// import axios from 'axios';
import axios from './axios';
import { Category, Product, StoreData } from '../interfaces/index';
import { toast } from 'react-toastify';
class ProductService {
  private storeId = localStorage.getItem('storeId');
  // private subStoreId = localStorage.getItem("storeId");

  private baseUrl: string = import.meta.env.VITE_BASEURL as string;

  public async getUserProducts(
    {
      x_pagination_cursor,
      filters,
    }: {
      x_pagination_cursor?: string;
      filters: {
        keyword?: string | null;
        categoryIds?: number[];
        tagName?: string | null;
        isActive?: boolean;
        isOutOfStock?: boolean;
      };
    } = {
      x_pagination_cursor: '',
      filters: {},
    }
  ): Promise<{
    products?: Product[];
    next?: string | null;
    previous?: string | null;
  }> {
    const params = new URLSearchParams();
    if (filters?.keyword) params.append('keyword', filters.keyword);
    if (filters?.categoryIds && filters.categoryIds.length > 0) {
      filters.categoryIds.forEach((id) =>
        params.append('categoryIds', String(id))
      );
    }
    if (filters?.tagName) params.append('tagName', filters.tagName);

    if (filters?.isOutOfStock !== undefined)
      params.append('isOutOfStock', String(filters.isOutOfStock));
    params.append('isActive', 'true');
    const queryString = params.toString();
    const url = `${this.baseUrl}product/products${queryString ? `?${queryString}` : ''}`;
    const config = {
      headers: {} as Record<string, string>,
    };
    if (x_pagination_cursor !== '') {
      config.headers['x-pagination-cursor'] = x_pagination_cursor || '';
    }
    try {
      const response = await axios.get(url, config);
      if (typeof response.data !== 'undefined') {
        if (typeof response.data.data !== 'undefined') {
          return {
            products: response.data.data.products,
            next: response.headers['x-pagination-next'],
            previous: response.headers['x-pagination-previous'],
          };
        } else {
          return {};
        }
      } else return {};
    } catch (error) {
      console.error('Error fetching user products:', error);
      throw error;
    }
  }

  public async getPublicInfo(
    storeId: string | number
  ): Promise<StoreData | null> {
    const url = `${this.baseUrl}store/public-info?x-store-id=${storeId}`;
    try {
      const response = await axios.get(url, {
        headers: { 'x-store-id': String(storeId) },
      });
      if (typeof response.data !== 'undefined') {
        if (typeof response.data.data !== 'undefined') {
          return response.data.data as StoreData;
        } else {
          return null;
        }
      } else return null;
    } catch (error) {
      console.error('Error fetching publicInfo:', error);
      throw error;
    }
  }
  public async getPublicStores(companyId: string | number) {
    const url = `${this.baseUrl}company/public/stores?companyId=${companyId}`;

    try {
      const response = await axios.get(url);
      if (typeof response.data !== 'undefined') {
        if (typeof response.data.data !== 'undefined') {
          return response.data.data;
        } else {
          return [];
        }
      } else return [];
    } catch (error) {
      console.error('Error fetching publicStores:', error);
      throw error;
    }
  }

  public async getPublicBanner(
    companyId: string | number
  ): Promise<string[] | null> {
    const params = new URLSearchParams({ companyId: String(companyId) });
    const url = `${this.baseUrl}company/public/storefront-banner?${params.toString()}`;
    try {
      const response = await axios.get(url);

      if (Array.isArray(response.data?.data)) {
        return response.data.data;
      }
      return null;
    } catch (error) {
      console.error('Error fetching publicBanner:', error);
      throw error;
    }
  }

  public async selectMimicStore({
    storeId,
    sessionId,
  }: {
    storeId: string | number;
    sessionId: number | string;
  }) {
    const url = `${this.baseUrl}mimic/session/select-store?sessionId=${sessionId}&storeId=${storeId}`;
    toast('Please wait while we redirect you to WhatsApp');
    try {
      const response = await axios.post(url);
      const message =
        response.data?.data?.message ||
        response.data?.message ||
        'Store selected';
      return { message, success: true };
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
      let m = '';
      if (error.response?.data?.errors) {
        const formattedErrors = Object.entries(
          error.response?.data?.errors ?? {}
        ).map(
          ([field, messages]) =>
            `${field} - ${(messages as string[]).join(', ')}`
        );
        m = formattedErrors.join('\n');
      }
      const message =
        m ||
        error?.response?.data?.message ||
        error.message ||
        'Error selecting store';
      return { message, success: false };
    }
  }
  public async getCategories(): Promise<Category[]> {
    const url = `${this.baseUrl}category/categories?&storeId=${this.storeId}`;
    try {
      const response = await axios.get(url);
      if (typeof response.data !== 'undefined') {
        return response.data.data;
      } else {
        return [];
      }
    } catch (error) {
      console.error('Error fetching categories:', error);
      throw error;
    }
  }
}

export default new ProductService();
